export class BeanSlideMenu{
  constructor(
    public menuIdCdMenu : string,
    public menuNmMenu	   : string,
    public menuDhInativo   : string,
    public slide   : boolean
  ){}
}